// src/App.tsx
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ContactModalProvider } from './context/ContactModalContext';
import { TrialsProvider } from './context/TrialsContext';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import TrialsPage from './components/TrialsPage/TrialsPage';
import TrialDetailPage from './components/TrialsPage/TrialDetailPage';
import BackToTopButton from './components/BackToTopButton/BackToTopButton';

const App: React.FC = () => {
  const showHeader = import.meta.env.VITE_SHOW_HEADER === 'true';

  return (
    <BrowserRouter>
      <ContactModalProvider>
        <BackToTopButton />
        <TrialsProvider>
          <main
            style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}
          >
            <div>
              {showHeader && <Header />}
              <Routes>
                <Route path="/trials" element={<TrialsPage />} />
                <Route path="/" element={<TrialsPage />} />
                <Route path="/trials/:nctId" element={<TrialDetailPage />} />
              </Routes>
            </div>
            <Footer />
          </main>
        </TrialsProvider>
      </ContactModalProvider>
    </BrowserRouter>
  );
};

export default App;
